module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_5.e57494d3.jpg";